import React, {
    createContext,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import axiosConfig from "../util/axiosConfig";
import { API_ENDPOINTS } from "../util/apiEndpoints";
import { useNavigate } from "react-router-dom";

export const AppContext = createContext({
    user: null,
    setUser: () => { },
    customer: null,
    loadingCustomer: true,
});

const getDomainAndSubdomain = () => {
    const host = window.location.hostname;
    const parts = host.split(".");

    if (parts.length < 2) {
        return { domain: null, subdomain: null };
    }

    const subdomain = parts[0];
    const domainPart = parts.slice(1).join(".");

    const domain = domainPart.split('.')[0]
    if (!domain.includes("belageri")) return { domain: null, subdomain: null };


    return { domain, subdomain };
};

export const AppContextProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [loadingCustomer, setLoadingCustomer] = useState(true);
    const navigate = useNavigate();
    const hasLoaded = useRef(false);
    useEffect(() => {
        const token = localStorage.getItem("token");

        if (token) {
            setUser({ token }); // minimal restore
        }
    }, []);
    useEffect(() => {
        if (hasLoaded.current) return;
        hasLoaded.current = true;

        const loadCustomerInfo = async () => {
            const { domain, subdomain } = getDomainAndSubdomain();

            // Could not parse → unauthorized
            if (!domain || !subdomain) {
                navigate("/unauthorized", { replace: true });
                return;
            }

            try {
                const url = API_ENDPOINTS.VALIDATE_TENANT(domain, subdomain); // backend remains same for now
                const res = await axiosConfig.get(url);

                // If Axios interceptor didn’t redirect → we got a valid customer response
                setCustomer(res.data);
                console.log("Loaded customer info:", res.data);
            } catch (err) {
                const status = err?.response?.status;

                // ❌ Subdomain does not exist OR invalid tenant
                if (status === 401 || status === 404) {
                    navigate("/unauthorized", { replace: true });
                } else if (status === 402) {
                    if (window.location.pathname !== "/subscription-expired") {
                        window.location.href = "/subscription-expired";
                    }
                }
                else {
                    console.error("Unexpected error:", err);
                }
            } finally {
                setLoadingCustomer(false);
            }
        };

        loadCustomerInfo();
    }, [navigate]);

    const contextValue = {
        user,
        setUser,
        customer,
        loadingCustomer,
    };

    return (
        <AppContext.Provider value={contextValue}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => useContext(AppContext);
